module.exports = __webpack_public_path__ + "img/ic_personal.743cff84.png";